import { useState, useRef, useCallback } from "react"

// Dates live at UTC midnight so a day is exactly 86 400 000 ms, whatever the DST changes.

export const toDate = value => {
  if (!value) return null
  const [y, m, d] = String(value).slice(0, 10).split("-").map(Number)
  return new Date(Date.UTC(y, m - 1, d))
}

export const todayUTC = () => {
  const now = new Date()
  return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()))
}

export const addDays     = (date, n) => new Date(date.getTime() + n * 86400000)
export const daysBetween = (a, b) => Math.round((b.getTime() - a.getTime()) / 86400000)
export const fmtISO      = date => date.toISOString().slice(0, 10)
export const fmtShort    = value => value
  ? new Date(`${String(value).slice(0, 10)}T00:00:00`).toLocaleDateString(I18n.locale, { day: "2-digit", month: "2-digit", year: "numeric" })
  : ""
export const monthName   = index => (I18n.t("date.abbr_month_names") || [])[index + 1] || ""

export const snapAxis = (dates, minDays) => {
  let start = new Date(Math.min(...dates.map(d => d.getTime())))
  let end   = new Date(Math.max(...dates.map(d => d.getTime())))
  if (daysBetween(start, end) < minDays) end = addDays(start, minDays)
  start = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), 1))
  end   = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth() + 1, 0))
  return { start, end, days: daysBetween(start, end) + 1 }
}

export const monthColumns = (axis, dayW, xFromDate) => {
  const out = []
  let cursor = new Date(axis.start.getTime())
  while (cursor <= axis.end) {
    const monthEnd = new Date(Date.UTC(cursor.getUTCFullYear(), cursor.getUTCMonth() + 1, 0))
    out.push({
      x:     xFromDate(fmtISO(cursor)),
      w:     (daysBetween(cursor, monthEnd) + 1) * dayW,
      label: monthName(cursor.getUTCMonth()),
      year:  cursor.getUTCMonth() === 0 || out.length === 0 ? String(cursor.getUTCFullYear()) : null,
    })
    cursor = addDays(monthEnd, 1)
  }
  return out
}

// "Juil 2025" needs about 56px: label every month, every other one, or every third.
export const monthLabelEvery = dayW => (dayW * 30 >= 60 ? 1 : dayW * 30 >= 30 ? 2 : 3)

// Multiplied, so a hovered row never hides the gridlines.
export const ROW_HOVER_STYLE = { mixBlendMode: "multiply" }

// A callback ref, so a container that mounts after an empty state is still measured.
export const useContainerWidth = (initial = 960) => {
  const [width, setWidth] = useState(initial)
  const observer = useRef(null)
  const ref = useCallback(el => {
    observer.current?.disconnect()
    observer.current = null
    if (!el) return
    const measure = () => setWidth(el.clientWidth)
    measure()
    observer.current = new ResizeObserver(measure)
    observer.current.observe(el)
  }, [])
  return [ref, width]
}
